import { ChangeEvent, FormEvent } from "react";
import { useSearchStore, useUIStore } from "../store";

import { useEffect } from "react";

export const useFormSearch = () => {
  const inputValue = useSearchStore((s) => s.inputValue);
  const setQuery = useSearchStore((s) => s.setQuery);
  const setInputValue = useSearchStore((s) => s.setInputValue);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setQuery(inputValue);
    }, 300); // ⏱ 300ms delay tipo apps reales

    return () => clearTimeout(timeout);
  }, [inputValue, setQuery]);

  return {
    inputValue,
    setInputValue,
  };
};